module.exports = __webpack_public_path__ + "media/images/ESQ-287e5f1c2913cd93b3b19284dc580ddd.png";